const loadMoreIndex = (lineCount: number, pageSize: number) => Math.max(lineCount - Math.ceil(pageSize / 2), 0);

export default loadMoreIndex;
